import { isSafari, isSafariDesktop } from "../../functions/browserChecks";
import { MICROPHONE_STATES } from "../HardwareChecks";
import { getMediaDevicePermissions } from "./getMediaDevicePermissions";
import hasAudioInputAccess from "./hasAudioInputAccess";

export default function waitForManualPermissionChange(){

    let interval;

    function start(setPermissionState){
        interval = setInterval(async ()=>{
            const gotAccess = await hasAudioInputAccess()
            if(gotAccess){
                stop()
                setPermissionState(MICROPHONE_STATES.manually_granted)
            }
        }, 1500)
    }

    function stop(){
        clearInterval(interval)
    }

    return {
        start,
        stop
    }

}